import React from 'react'
import { getRelativeImageUrl } from '../utils/urls'
import { Image } from '../image/image'
import { ImageProps } from 'next/image'

type Props = {
  imageId: string | null
  imagePriority?: boolean
  slugText: string
  visible?: boolean
  fullScreen?: boolean
  _width?: `${number}` | number
  _height?: `${number}` | number
} & Omit<ImageProps, 'alt' | 'src'>

const Slide = ({
  imageId,
  imagePriority = false,
  slugText,
  visible = true,
  fullScreen,
  _width,
  _height,
  ...props
}: Props) => {
  const width = fullScreen ? 800 : 400
  const height = fullScreen ? 640 : 320
  const imageUrl = getRelativeImageUrl(imageId, width, height, slugText)

  return (
    <div className="c-imageslider__image-wrap">
      {visible && (
        <Image
          src={imageUrl}
          alt={slugText}
          onMouseDown={(e: any) => e.preventDefault()}
          priority={imagePriority}
          width={_width || width}
          height={_height || height}
          {...props}
        />
      )}
    </div>
  )
}

export default Slide
